export default __webpack_public_path__ + "static/media/ring-1@2x.69f42afd.jpg";